import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CloserSyncInstruction } from '@models/mortgages/closer-sync-instruction';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { ViewSelectSnapshot } from '@ngxs-labs/select-snapshot';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { MatterFileType } from '@models/matter';

@UntilDestroy()
@Component({
	selector: 'app-closer-sync-review-mortgage-details',
	templateUrl: './closer-sync-review-mortgage-details.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncReviewMortgageDetailsComponent {
	public instruction$: Observable<CloserSyncInstruction>;
	@ViewSelectSnapshot(SelectedMatter.matterFileType) fileType: MatterFileType;

	@Input()
	set instruction(instruction$: Observable<CloserSyncInstruction>) {
		this.instruction$ = instruction$.pipe(untilDestroyed(this));
	}

	get isPurchase(): boolean {
		return this.fileType === MatterFileType.PURCHASE;
	}
}
